import { useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { useDashboardProfile } from '../context/DashboardProfileContext';
import { AccountDialog } from './AccountDialog';

export function UserMenu() {
  const { user } = useAuth();
  const { profile } = useDashboardProfile();
  const [accountOpen, setAccountOpen] = useState(false);
  const displayName =
    profile?.nome || user?.displayName || user?.email?.split('@')[0]?.replace(/\./g, ' ') || 'Pesquisador';

  return (
    <>
      <button
        type="button"
        onClick={() => setAccountOpen(true)}
        title="Minha conta"
        className="flex items-center gap-3 shrink-0 rounded-full hover:opacity-80 transition-opacity"
      >
        {profile?.fotoUrl ? (
          <img src={profile.fotoUrl} alt="" className="w-8 h-8 rounded-full object-cover shrink-0" />
        ) : (
          <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center text-xs font-semibold text-primary uppercase shrink-0">
            {displayName.charAt(0)}
          </div>
        )}
        <div className="hidden sm:block min-w-0 text-left">
          <p className="text-sm font-medium text-foreground truncate capitalize">
            {displayName}
          </p>
          <p className="text-[11px] text-primary font-medium truncate max-w-[160px]">
            Ver minha conta
          </p>
        </div>
      </button>

      <AccountDialog open={accountOpen} onOpenChange={setAccountOpen} />
    </>
  );
}
